import { directSupabase } from '../lib/supabaseClient';

export interface BillToCompany {
  id: string;
  name: string;
  address?: string | null;
  email?: string | null;
  phone?: string | null;
  logo_url?: string | null;
  vat_number?: string | null;
  company_number?: string | null;
  payment_terms?: string | null;
  bank_sort_code?: string | null;
  bank_account_number?: string | null;
  is_active?: boolean | null;
}

export const billToService = {
  async listActive(): Promise<BillToCompany[]> {
    const { data, error } = await directSupabase
      .from('bill_to_companies')
      .select('*')
      .eq('is_active', true)
      .order('name', { ascending: true });
    if (error) throw new Error(error.message);
    return (data || []) as BillToCompany[];
  },

  async upsert(company: Partial<BillToCompany>): Promise<BillToCompany> {
    const { data, error } = await directSupabase
      .from('bill_to_companies')
      .upsert({ ...company, updated_at: new Date().toISOString() })
      .select('*')
      .single();
    if (error) throw new Error(error.message);
    return data as BillToCompany;
  }
};


